import { z } from 'zod';

export const getImpactAnswersDtoSchema_Generator = z.array(
  z.object({
    id: z.number(),
    userId: z.string(),
    projectId: z.number(),
    sector: z.string(),
    fuelType: z.string(),
    fuelConsumption: z.string(),
    hasGenerator: z.boolean(),
    isExternal: z.boolean(),
    label: z.string().nullable(),
    source: z.string().nullable(),
    score: z.number().optional(),
    tags: z
      .object({
        values: z
          .array(z.object({ id: z.number(), name: z.string() }))
          .optional(),
      })
      .optional(),
  }),
);

export type QuestionGeneratorDto = {
  id: number;
  userId: string;
  projectId: number;
  sector: string;
  fuelType: string;
  fuelConsumption: number | string;
  hasGenerator: boolean;
  isExternal: boolean;
  label: string | null;
  source?: string | null;
  score?: number;
  tags?: { values?: Array<{ id: number; name: string }> };
};
